<template>
  <b-container fluid>
    <h1 class="m-3">
      {{ title }}
    </h1>
    <commonActions :data-ready="dataReadyTables" :filename-prefix="title"
      @commonFiltersUpdated="commonFiltersUpdated($event)" @clickDownloadPdf="downloadPdf($event)"
      @clickDownloadExcel="downloadExcel($event)" @clickDownloadCsv="downloadCsv($event)" />
    <table-renderer v-for="data of tablesData" :key="data.tableNumber" ref="tableRenderers" :data-table="data.dataTable"
      :dimension-fields="dimensionColumnsTables" :measure-fields="measureColumnsTables" :table-header="data.tableHeader"
      :default-sorted-column="defaultSortedColumnTables" :totals-data="data.totalsData" :data-ready="dataReadyTables"
      :custom-table-class="customTableClass" />
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import Tools from "@/utils/tools";
import TableTools from "@/utils/tableTools";
import paths from "@/router/pathConstants";
import TableRenderer from "@/components/TableRenderer.vue";
import commonActions from "@/components/pages/commonActions";
import { KioskGlobal } from "@/router/routeNames";


export default {
  name: KioskGlobal,
  components: {
    TableRenderer,
    commonActions,
  },
  data() {
    return {
      /** Tableau de filtres tels qu'attendu par cubeJs.
       * Ex :
       *    [
       *      {
       *        dimension: "Site.Id",
       *        operator: "equals",
       *        values: ["85007419-23D3-48AB-89E7-68089F46FA7D"]
       *      },
       *      {
       *        dimension: "BusinessDate.id",
       *        operator: "inDateRange",
       *        values: ["2020-09-23", "2020-09-26"]
       *      },
       */
      commonFilters: [],
    };
  },
  computed: {
    ...mapState({
      dimensionColumnsTables: (state) =>
        state.kioskGlobal.dimensionColumnsTables,
      measureColumnsTables: (state) => state.kioskGlobal.measureColumnsTables,
      defaultSortedColumnTables: (state) =>
        state.kioskGlobal.defaultSortedColumnTables,
      tablesData: (state) => state.kioskGlobal.tablesData,
      dataReadyTables: (state) => state.kioskGlobal.dataReadyTables,
    }),
    title() {
      return this.$t("title.kiosk_global");
    },
    customTableClass() {
      return "table-width-medium";
    }
  },
  mounted() {
    this.$store.dispatch("kioskGlobal/initDisplayTables");
    if (this.$route.query.siteId) {
      Tools.StorageHelper.storeFilterSelectedValue("Site.id", [
        this.$route.query.siteId.toUpperCase(),
      ]);
    }
  },
  methods: {
    async commonFiltersUpdated(value) {
      try {
        this.$store.dispatch("kioskGlobal/resetDataReadyTables");
        this.commonFilters = value.filters;
        await this.$store.dispatch("kioskGlobal/updateTableList", {
          filters: this.commonFilters,
          timeDimension: value.timeDimension || null,
          siteValues: value.siteValues,
        });
      } catch (error) {
        Tools.Alerts.Error(this.$swal, error);
      }
    },
    downloadPdf(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_PDF, "_blank");
      }
    },
    downloadExcel(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_EXCEL, "_blank");
      }
    },
    downloadCsv(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_CSV, "_blank");
      }
    },
    storeExportData(filename, subtitles) {
      const self = this;
      var datasForExport = [];

      self.tablesData.forEach((table, index) => {
        const renderer = self.$refs.tableRenderers?.[index];
        const sortKey = renderer?.sortedColumn || self.defaultSortedColumnTables;

        const data = TableTools.Helper.assembleExportDataTable(
          table.dataTable,
          self.dimensionColumnsTables,
          self.measureColumnsTables,
          null,
          table.tableHeader,
          sortKey,
          null,
          table.totalsData
        );
        datasForExport.push(data);
      });

      TableTools.Helper.storeExportData(
        datasForExport,
        self.title,
        subtitles,
        filename
      );
    },
  },
};
</script>
